var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45523 13.0452L3.63373 14.4827V29.0287H3.63323C3.63323 29.5312 4.04123 29.9392 4.54423 29.9392H13.1977C13.7007 29.9392 14.1087 29.5312 14.1087 29.0287V23.5632C14.1087 22.0332 15.3117 20.8302 16.8412 20.8302C18.3712 20.8302 19.5742 22.0332 19.5742 23.5632V29.0287H19.5737C19.5737 29.5312 19.9817 29.9392 20.4847 29.9392H29.1382C29.6412 29.9392 30.0492 29.5312 30.0492 29.0287V14.4827L28.2272 13.0447V28.1172H21.3957V23.5627C21.3957 21.0552 19.3487 19.0082 16.8412 19.0082C14.3337 19.0082 12.2867 21.0552 12.2867 23.5627V28.1172H5.45473V13.0447L5.45523 13.0452ZM16.8157 0.000217371C16.6442 0.00371737 16.4842 0.0617174 16.3307 0.170217L0.809726 12.7262C0.452726 13.0202 0.402226 13.5622 0.669226 13.9162C0.932726 14.2652 1.49323 14.3212 1.83073 14.0472L16.8412 1.90972L31.8517 14.0472C32.1892 14.3212 32.7342 14.2632 33.0002 13.9162C33.2647 13.5722 33.2362 13.0002 32.8727 12.7262L17.3517 0.170217C17.1702 0.0472174 16.9872 -0.00378263 16.8157 0.000217371Z",
    className: "color3Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/iconHome.45863a4bb7179ca75e67fac2d2573aa4.svg";
export { ForwardRef as ReactComponent };